import type { SelectedInstrument } from '@/types/dashboard'

const normalizeKind = (kind: string) =>
  kind === 'perps' || kind === 'perp' || kind === 'future' || kind === '2' ? 'derivative' : kind

/** Identity shared by every order-form instrument entry point. */
export function getSelectedInstrumentRowKey(instrument: SelectedInstrument) {
  const exchange = instrument.exchange ?? ''
  const kind = normalizeKind(instrument.instrumentKind)
  const symbol = instrument.symbol.trim().toUpperCase()
  // Prefer the raw symbol when available — it's the one field every entry point
  // (TradingView broker widget, watch-list table/view) sets identically for the
  // same instrument. baseCurrency/quoteCurrency are derived independently per
  // entry point and can diverge (canonical instrument fields vs. symbol-string
  // parsing fallback), which previously caused the same instrument added from
  // two different UIs to be treated as distinct rows.
  if (symbol) return `${exchange}:${kind}:${symbol}`
  const base = instrument.baseCurrency.trim().toUpperCase()
  const quote = instrument.quoteCurrency.trim().toUpperCase()
  const contract = base && quote ? `${base}/${quote}` : ''
  const maturity = instrument.expirationTsMs ?? ''
  return `${exchange}:${kind}:${contract}:${maturity}`
}

export function areSameSelectedInstrument(left: SelectedInstrument, right: SelectedInstrument) {
  return getSelectedInstrumentRowKey(left) === getSelectedInstrumentRowKey(right)
}
